var exports = {
  "kL": "x7be19a29--f961ba--container",
  "xk": "x7be19a29--f961ba--props",
  "_w": "x7be19a29--f961ba--prop",
  "It": "x7be19a29--f961ba--rates",
  "TS": "x7be19a29--f961ba--rate",
  "Uq": "x7be19a29--f961ba--value",
};

module.exports = exports;
